<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      ref="searchBox"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    >
      <div slot="waitDeal" slot-scope="prop">
        <el-checkbox label="待我处理" name="type" v-model="prop.form.waitDeal" />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  watch: {
    '$route.query.state': function () {
      this.jumpHereSearchState();
    },
  },
  data () {
    return {
      searchBoxData: {
        launchOptions: [], // 借支入口
        stateOptions: [], // 借支状态
        // loanSubjectOptions: [], // 借支类型
        form: [
          { // 快速过滤
            label: '',
            value: 'waitDeal',
            default: true,
            slot: true,
            normalFormNotCount: true,
            class: 'next-search-btn',
          },
          {
            label: '',
            value: 'state',
            type: 'radio',
            default: -1,
            class: 'especial-radio-group',
            normalFormNotCount: true,
            onChangeRadio: () => {
              this.$refs.searchBox.sub();
            },
          },
          { // 借支类型
            label: '借支类型',
            value: 'loanType',
            type: 'select',
            default: -1,
            placeholder: '请选择核销类别',
            options: [
              { label: '全部', value: -1 },
              { label: '司机出车借支', value: 1 },
              { label: '车辆维护借支', value: 2 },
              { label: '员工借支', value: 3 },
            ],
          },
          { // 申请人
            label: '申请人',
            value: 'userName',
            type: 'input',
            placeholder: '请输入申请人姓名',
          },
          { // 申请时间
            label: '申请时间',
            value: 'Time',
            type: 'date',
            default: [],
            placeholder: '请选择借支时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 手机号码
            label: '手机号码',
            value: 'mobilePhone',
            type: 'input',
            placeholder: '请输入申请人手机号',
          },
          { // 收款人
            label: '收款人',
            value: 'accName',
            type: 'input',
            placeholder: '请输入收款人姓名',
          },
          { // 借支单号
            label: '借支单号',
            value: 'oaLoanId',
            type: 'input',
            placeholder: '请输入借支单号',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          // { // 订单号码
          //   label: '订单号码',
          //   value: 'orderId',
          //   type: 'input',
          //   placeholder: '请输入订单号码',
          // },
          // { // 支付流水号
          //   label: '支付流水号',
          //   value: 'payIdStr',
          //   type: 'input',
          //   placeholder: '请输入支付流水号',
          // },
          // { // 借支金额
          //   label: '借支金额',
          //   value: 'amount',
          //   type: 'inputrange',
          //   placeholder: '请输入借支金额',
          // },
          // { // 未核销金额
          //   label: '未核销金额',
          //   value: 'noPayed',
          //   type: 'inputrange',
          //   placeholder: '请输入未核销金额',
          // },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 申请时间
      if (searchBoxData.Time && searchBoxData.Time.length) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
      }

      this.$refs.tableBox.saveSearchBoxData({
        borrowType: -1,
        loanType: -1,
        threeOrgId: -1,
        twoOrgId: -1,
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'LOAN_STATE,LOAN_SUBJECT,BORROW_ENTRANCE',
    });
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    // this.searchBoxData.loanSubjectOptions = [
    //   {
    //     label: '全部',
    //     value: -1,
    //   },
    //   ...enumsList[1],
    // ];
    this.searchBoxData.launchOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[2],
    ];
  },
  activated () {
    // 第一次进入
    const state = this.$route.query.state;
    if (state) {
      this.$refs.searchBox.setVal('state', state);
    }

    const waitDeal = this.$route.query.waitDeal;
    if (waitDeal) {
      this.$refs.searchBox.setVal('waitDeal', true);
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .next-search-btn {
  position: absolute;
  left: calc(100% - 330px);
  top: 110px;
  width: 100px !important;
}
</style>
